

export const clearFilterData = {
  DrvNm: "",
  PaySts: null,
}

export const initFilterData = { 
  ...clearFilterData,
}

export const initDriverAdvancePay = {
  PCTrnsId: null,
  PCItmId: null,
  ExpId: null,
  DrvId: null,
  Dscp: "",
  PayTm: null,
  Amnt: "",
  PCJnlId: null,
  PCPrdId: null,
}